document.addEventListener("DOMContentLoaded", function () {
    const articles = document.querySelectorAll('.blog__articles--article');

    if (articles.length > 0) {
        const handleScroll = () => {
            articles.forEach(article => {
                const rect = article.getBoundingClientRect();
                if (rect.top <= window.innerHeight && rect.bottom >= 0) {
                    if (article.classList.contains('blog__article--block-large')) {
                        setTimeout(() => {
                            article.classList.add('visible');
                        }, 300);
                    } else {
                        setTimeout(() => {
                            article.classList.add('visible');
                        }, 100);
                    }
                }
            });
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);
    }
});